import { render, staticRenderFns } from "./EmailHistory.vue?vue&type=template&id=186c1700&scoped=true"
import script from "./EmailHistory.vue?vue&type=script&lang=js"
export * from "./EmailHistory.vue?vue&type=script&lang=js"
import style0 from "./EmailHistory.vue?vue&type=style&index=0&id=186c1700&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "186c1700",
  null
  
)

export default component.exports